import React, { useCallback } from 'react';
import { Box } from '@common-fe/common-fe';

import { LockboxCheck, LockboxCheckType } from '@/modules/employer/components/Lockbox/lockbox.types';
import { MatchingListWrapper } from '@/modules/employer/components/Lockbox/LockboxDetails/components/LockboxInfo/LockboxMatchingList';
import useLockboxDetailsStore from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useLockboxDetails.store';

import ChecksSearch from './ChecksSearch';
import SuggestedChecks from './SuggestedChecks';

const SelectChecks = () => {
  const { editableLockbox, setEditableLockbox } = useLockboxDetailsStore();
  const selectedCheckId = editableLockbox?.selectedCheckId;

  const handleSelectCheck = useCallback(
    (checkId?: string, checkType?: LockboxCheckType, check?: LockboxCheck) => {
      setEditableLockbox({
        selectedCheckId: checkId,
        selectedCheckType: checkType,
        check: check,
        remainder: {
          addressLine1: check?.address?.line1,
          addressLine2: check?.address?.line2,
          city: check?.address?.city,
          state: check?.address?.state?.code,
          zip: check?.address?.zipcode,
          undeliverable: true,
        }
      });
    },
    [setEditableLockbox]
  );

  return (
    <MatchingListWrapper title="Check">
      <SuggestedChecks
        selectedCheckId={selectedCheckId}
        onSelectCheck={handleSelectCheck}
      />
      <Box margin={{ top: 'spacing24' }}>
        <ChecksSearch
          selectedCheckId={selectedCheckId}
          onSelectCheck={handleSelectCheck}
        />
      </Box>
    </MatchingListWrapper>
  );
};

export default SelectChecks;
